import acl from '@/utils/accessLevels';

const isUserTypeFromAclGroup = {
  methods: {
    isUserTypeFromAclGroup(aclKey) {
      const { currentUser } = this.$store.state;
      if (currentUser) {
        return acl[aclKey].includes(currentUser.type);
      }
      return false;
    },
  },
};

export default isUserTypeFromAclGroup;



// WEBPACK FOOTER //
// ./src/mixins/isUserTypeFromAclGroup.js